export default theme => ({
  root: {
    maxWidth: 900,
    paddingBottom: theme.spacing(4),
    '& .MuiTypography-h6': {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(3)
    }
  },
  actions: {
    marginTop: theme.spacing(3),
    '& .MuiButton-root': {
      marginRight: theme.spacing(2)
    }
  },
  invoiceTable: {
    marginTop: theme.spacing(2.5),
    '& .MuiDataGrid-cell[data-field=total]': {
      fontWeight: 700
    }
  }
});
